export default "__VITE_ASSET__DVl5v1vp__"